const [
	ENTITY_NODE_CONTAINER_WIDTH,
	ENTITY_NODE_WIDTH,
	ENTITY_NODE_PADDING,
	ENTITY_NODE_GAP,
] = [480 + 16 * 2, 480, 8, 8] as const;

export {
	ENTITY_NODE_CONTAINER_WIDTH,
	ENTITY_NODE_GAP,
	ENTITY_NODE_PADDING,
	ENTITY_NODE_WIDTH,
};
